import { render, staticRenderFns } from "./StepConfirmation.vue?vue&type=template&id=5c7ef0e9&scoped=true"
import script from "./StepConfirmation.vue?vue&type=script&lang=ts"
export * from "./StepConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./StepConfirmation.vue?vue&type=style&index=0&id=5c7ef0e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ef0e9",
  null
  
)

export default component.exports